import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { BootstrapIcon } from '../BootstrapIcon';

import './Discriminators.css';


// Bootstrap replacement icons
// on-premise club - building
// verified guests - person-check-fill
// members only - person-badge-fill
// discreet - incognito
// private rooms - shield-lock, key, possibly look for direct svg to use
// always fun - emoji-sunglasses
// no cameras - consider stacking icons?
//https://stackoverflow.com/questions/19589702/stacked-icons-with-one-css-class

const iconList = [
    { icon: 'building', caption: 'On-Premise Club' },
    { icon: 'ui-checks', caption: 'Verified Guests' }, // options person-check-fill, ui-checks
    { icon: 'person-badge', caption: 'Members Only' },
    { icon: 'incognito', caption: 'Discreet' },
    { icon: 'shield-lock', caption: 'Private Rooms' },
    { icon: 'chat-heart', caption: 'Always Fun' },  //options emoji-sunglasses, chat-text-fill, chat-heart-fill
    //{ icon: camera, caption: 'No Photos', not: true },
]

export function Discriminators() {
    const items = iconList.map((x) =>
        <Col xs="4" md="2" key={`discriminator-${x.icon}`}>
            <BootstrapIcon icon={x.icon} />
            {/* <span className="fa-stack fa-2x">
                <FontAwesomeIcon icon={item.icion} className="fa-stack-1x" />
                        {item.not ? <FontAwesomeIcon icon={faBan} className="fa-stack-2x" /> : null}
                        <FontAwesomeIcon icon={item.icion} />
            </span> */}
            <p>{x.caption}</p>
        </Col>
    )

    return (
        <div className="discriminator-panel">
            <Row>
                {items}
            </Row>
        </div>
    );
}

